
export default (state = {}, action) => {
  switch (action.type) {
    case 'UNSUBSCRIBE_BEGINS':
      return {
        loader: true,
        error: false,
        result: null
      }

    case 'UNSUBSCRIBE_SUCCESS':
      return {
        loader: false,
        error: false,
        result: action.payload
      }

    case 'UNSUBSCRIBE_FAILURE':
      return {
        loader: false,
        error: action.payload,
        result: null
      }
    case 'UNSUBSCRIBE_CLEAR':
      return {
        loader: false,
        error: false,
        result: null
      }
    default:
      return state
  }
}